import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFlipboardBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFlipboardBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '3b88b133550318f7761585f06b5fc8d4cb1ec5f5', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'f2571bffae955f44d85c9ee4aa0a1bae41e017f2', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'f80b0ac29cba88b8a901c10bc6b57e3386c19fda', d: "M20 2H2v18h18z", fill: "#C00" }), h("path", { key: '613513660972fe848e95d1d82096192949311153', d: "M12.8 9.2H9.2v3.6h3.6z", fill: "#F5CCCC" }), h("path", { key: 'd52c96929e3c5540d2f17f5be356230395de108c', d: "M16.4 5.6H9.2v3.6h7.2z", fill: "#FAE5E5" }), h("path", { key: '57b24ca7ddd4123df2a7d879f3e15c61458797e4', d: "M9.2 5.6H5.6v10.8h3.6z", fill: "#fff" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-flipboard-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-flipboard-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-flipboard-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFlipboardBranded$1);
            }
            break;
    } });
}

const CosmosIconFlipboardBranded = CosmosIconFlipboardBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFlipboardBranded, defineCustomElement };
